import React from "react";
import { Facebook, Instagram } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { trackSocialClick } from "../lib/analytics";

const FACEBOOK_URL = "https://www.facebook.com/share/1Jjt28LN1n/?mibextid=wwXIfr";
const INSTAGRAM_URL = "https://www.instagram.com/kinder_steps";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="bg-[#FDFBF7] border-t border-[#E2E8F0] py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <img
            src="/images/logo.jpg"
            alt="STEPS logo"
            className="w-16 h-16 md:w-20 md:h-20 rounded-2xl object-contain bg-white border border-[#E2E8F0]"
          />
          <div>
            <div className="font-fredoka text-lg md:text-xl text-[#1D3557] font-semibold">
              Centro Pedagógico Infantil STEPS
            </div>
            <div className="text-sm text-[#457B9D]">{t.footer.tagline}</div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <a
            data-testid="footer-facebook"
            href={FACEBOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackSocialClick("facebook", "footer")}
            aria-label="Facebook"
            className="w-11 h-11 rounded-full bg-[#1E5FBA] text-white grid place-items-center hover:bg-[#1D3557] hover:scale-110 transition-all shadow-md"
          >
            <Facebook className="w-5 h-5" strokeWidth={2.2} />
          </a>
          <a
            data-testid="footer-instagram"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackSocialClick("instagram", "footer")}
            aria-label="Instagram"
            className="w-11 h-11 rounded-full bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white grid place-items-center hover:scale-110 transition-transform shadow-md"
          >
            <Instagram className="w-5 h-5" strokeWidth={2.2} />
          </a>
        </div>

        <div className="text-sm text-[#457B9D]">
          © {year} STEPS. {t.footer.rights}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
